import { Routes } from '@angular/router';
import { authGuard } from '../../guards/auth.guard';

export const contactsRoutes: Routes = [
  {
    path: 'contacts',
    title: 'Kontakte',
    loadComponent: () => import('./contacts-list').then(m => m.ContactsListComponent),
    canActivate: [authGuard],
  },
];
